import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Alert = _resolveComponent("Alert")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.fetchUser && _ctx.fetchUser(...args))),
      disabled: _ctx.isSubmitting,
      class: "btn btn-primary"
    }, "User Details", 8, _hoisted_1),
    (_ctx.errorText.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_Alert, {
            type: "danger",
            text: _ctx.errorText
          }, null, 8, ["text"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.user)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("p", null, "Email: " + _toDisplayString(_ctx.user.email), 1),
          _createElementVNode("p", null, "Plan: " + _toDisplayString(_ctx.user.plan?.name || 'None'), 1),
          _createElementVNode("p", null, "Disabled: " + _toDisplayString(_ctx.user.disabled), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}